import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon, InstallIcon } from './Icons';
import {
  dismissInstallPrompt,
  isIosSafari,
  promptNativeInstall,
  shouldShowInstallPrompt,
  watchInstallAvailability,
} from '../services/pwa';

export function InstallBanner() {
  const { t } = useTranslation();
  const [, bump] = useState(0);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => watchInstallAvailability(() => bump((value) => value + 1)), []);

  if (!shouldShowInstallPrompt()) return null;

  const ios = isIosSafari();

  return (
    <div className="install-chip">
      <button
        type="button"
        className="install-chip__main"
        onClick={() => {
          if (ios) setIosHelp((open) => !open);
          else void promptNativeInstall();
        }}
      >
        <InstallIcon size={18} />
        <span>{t('install.label')}</span>
      </button>
      <button type="button" className="install-chip__close" aria-label={t('install.later')} onClick={dismissInstallPrompt}>
        <CloseIcon size={14} />
      </button>
      {ios && iosHelp && (
        <p className="install-chip__help">
          {t('install.iosBefore')} <strong>{t('install.share')}</strong> {t('install.iosMid')} <strong>{t('install.addHome')}</strong>.
        </p>
      )}
    </div>
  );
}
